module.exports = __webpack_public_path__ + "static/media/background_demo2.c7e00d44.apng";